import * as React from 'react'
import { tw } from 'utils/classnames'

export const TagButton = function TagButton({
  ref,
  children,
  selectedClassName,
  variant = 'default',
  size = 'medium',
  onClick,
  ...props
}: React.ComponentProps<'a'> & {
  variant?: 'default' | 'selected'
  size?: 'small' | 'medium'
  selectedClassName?: string
}) {
  return (
    <a
      type="button"
      href={`?tags=${children?.toString()}`}
      onClick={e => {
        e.preventDefault()
        onClick?.(e)
      }}
      {...props}
      ref={ref}
      className={tw(
        // no outline on select buttons since they almost all trigger by hover
        'outline-none',
        size === 'medium' && 'h-[33px]',
        size === 'small' && 'h-[25px]',
        'border-gray-600-300 flex items-center gap-[14px] rounded-full border px-[12px] text-gray-300',
        'hover:text-service-white-white hover:border-violet-500 hover:bg-violet-500',
        variant === 'selected' &&
          tw('text-service-white-white border-violet-500 bg-violet-500', selectedClassName),
        props.className,
      )}
    >
      {children}
    </a>
  )
}
